<template>
  <el-dialog
    :title="title"
    :visible.sync="visibleSync"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="账号" prop="account">
        <el-input v-model="form.account" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="form.password" placeholder="不填则默认123456"></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-select v-model="form.role" placeholder="请选择角色" style="width: 100%;">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区县" prop="district">
        <el-cascader
          style="width: 100%;"
          v-model="selectedOptions"
          :options="regionData"
          :props="{ value: 'value', label: 'label', children: 'children' }"
          @change="handleChange"
          placeholder="请选择所属区县"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">停用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visibleSync = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";

export default {
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      regionData: regionData,
      selectedOptions: [],
      roleOptions: [],
      form: {
        id: null,
        account: "",
        password: "",
        role: "",
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        districtId: "",
        districtName: "",
        status: 1
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        role: [{ required: true, message: "请选择角色", trigger: "change" }]
      }
    };
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    title() {
      return this.form.id ? "编辑账号" : "新增账号";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    }
  },
  created() {
    this.initRoleOptions();
  },
  methods: {
    initRoleOptions() {
      const userInfoStr = localStorage.getItem("adminUserInfo");
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        if (userInfo.role === "SUPER_ADMIN") {
          this.roleOptions = [
            { label: "管理员", value: "ADMIN" },
            { label: "工作人员", value: "STAFF" }
          ];
        } else if (userInfo.role === "ADMIN") {
          this.roleOptions = [{ label: "工作人员", value: "STAFF" }];
        }
      }
    },
    initForm() {
      if (this.data) {
        this.form = {
          id: this.data.id,
          account: this.data.account,
          password: "",
          role: this.data.role,
          provinceId: this.data.provinceId || "",
          provinceName: this.data.provinceName || "",
          cityId: this.data.cityId || "",
          cityName: this.data.cityName || "",
          districtId: this.data.districtId || "",
          districtName: this.data.districtName || "",
          status: this.data.status != null ? this.data.status : 1
        };
        if (this.form.provinceId && this.form.cityId && this.form.districtId) {
          this.selectedOptions = [
            String(this.form.provinceId),
            String(this.form.cityId),
            String(this.form.districtId)
          ];
        } else {
          this.selectedOptions = [];
        }
      } else {
        const userInfoStr = localStorage.getItem("adminUserInfo");
        let defaultDistrict = { provinceId: "", cityId: "", districtId: "" };
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          defaultDistrict = {
            provinceId: userInfo.provinceId || "",
            cityId: userInfo.cityId || "",
            districtId: userInfo.districtId || ""
          };
        }
        this.form = {
          id: null,
          account: "",
          password: "",
          role: this.roleOptions.length > 0 ? this.roleOptions[0].value : "",
          provinceId: defaultDistrict.provinceId,
          provinceName: "",
          cityId: defaultDistrict.cityId,
          cityName: "",
          districtId: defaultDistrict.districtId,
          districtName: "",
          status: 1
        };
        if (defaultDistrict.provinceId && defaultDistrict.cityId && defaultDistrict.districtId) {
          this.selectedOptions = [
            String(defaultDistrict.provinceId),
            String(defaultDistrict.cityId),
            String(defaultDistrict.districtId)
          ];
          this.form.provinceName = CodeToText[String(defaultDistrict.provinceId)] || "";
          this.form.cityName = CodeToText[String(defaultDistrict.cityId)] || "";
          this.form.districtName = CodeToText[String(defaultDistrict.districtId)] || "";
        } else {
          this.selectedOptions = [];
        }
      }
    },
    handleChange(value) {
      this.form.provinceId = value[0] || "";
      this.form.provinceName = CodeToText[value[0]] || "";
      this.form.cityId = value[1] || "";
      this.form.cityName = CodeToText[value[1]] || "";
      this.form.districtId = value[2] || "";
      this.form.districtName = CodeToText[value[2]] || "";
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        if (!this.form.districtId) {
          this.$message.error("请选择所属区县");
          return;
        }
        this.$apis.post("/admin/backendUser/saveOrUpdate", this.form).then(res => {
          if (res.data.code == 200) {
            this.$message.success("保存成功");
            this.visibleSync = false;
            this.$emit("success");
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        });
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/components/addOrEditBackendUser.vue